/*
 * Audience popup — asks whether the visitor is a pet owner or veterinary professional.
 * - "Pet owner" simply closes the popup.
 * - "Veterinary professional" redirects to the registration page.
 *
 * Shows on every new shop visit (browser session) for guests who are not logged in.
 * Within the same session it only auto-opens once; the teaser can reopen it manually.
 * While it is pending/open it sets window.audiencePopupPending so the newsletter
 * popup can wait and both never appear at the same time.
 */
if (!customElements.get('audience-popup')) {
  customElements.define(
    'audience-popup',
    class AudiencePopup extends ModalComponent {
      constructor() {
        super();
        this.storageKey = 'amamusvet:audience-popup';

        if (!Shopify.designMode && !this.hasBeenAnsweredThisSession()) {
          window.audiencePopupPending = true;
        }
      }

      get isLockingNeeded() {
        return true;
      }

      get requiresBodyAppended() {
        return true;
      }

      connectedCallback() {
        super.connectedCallback();

        if (!this.hasOpened) {
          window.FoxTheme.DOMready(this.handleOpen.bind(this));
        }
      }

      hasBeenAnsweredThisSession() {
        try {
          return sessionStorage.getItem(this.storageKey) === '1';
        } catch {
          return false;
        }
      }

      markAnsweredThisSession() {
        try {
          sessionStorage.setItem(this.storageKey, '1');
        } catch {
          /* sessionStorage unavailable */
        }
      }

      handleOpen() {
        if (Shopify.designMode) return;
        if (this.hasOpened) return;

        if (this.hasBeenAnsweredThisSession()) {
          this.releaseSlot();
          return false;
        }

        this.hasOpened = true;
        this.show();
      }

      releaseSlot() {
        window.audiencePopupPending = false;
        document.dispatchEvent(new CustomEvent('audience-popup:dismissed'));
      }

      prepareToShow() {
        super.prepareToShow();
        this.markAnsweredThisSession();
      }

      handleAfterHide() {
        super.handleAfterHide();
        this.releaseSlot();
      }
    }
  );
}
